export function parseCsv(text: string): string[][] {
  const rows: string[][] = [];
  let row: string[] = [];
  let cell = "";
  let quoted = false;
  for (let index = 0; index < text.length; index += 1) {
    const char = text[index];
    if (quoted) {
      if (char === '"' && text[index + 1] === '"') { cell += '"'; index += 1; }
      else if (char === '"') quoted = false;
      else cell += char;
    } else if (char === '"') quoted = true;
    else if (char === ",") { row.push(cell.trim()); cell = ""; }
    else if (char === "\n") { row.push(cell.trim()); if (row.some(Boolean)) rows.push(row); row = []; cell = ""; }
    else if (char !== "\r") cell += char;
  }
  row.push(cell.trim());
  if (row.some(Boolean)) rows.push(row);
  return rows;
}

function value(record: Record<string, string>, ...names: string[]): string {
  for (const name of names) if (record[name] != null) return record[name];
  return "";
}

function minorUnits(raw: string): number {
  const normalized = raw.replace(/[^0-9.-]/g, "");
  return normalized ? Math.round(Number(normalized) * 100) : 0;
}

export interface ImportRow {
  source: string; externalReference: string; guestName: string; email: string; phone: string; language: string;
  checkInDate: string; checkOutDate: string; roomName: string; bedLabel: string; adults: number; children: number;
  currency: string; totalMinor: number; channelCollectedMinor: number;
}

export function mapSpreadsheetCsv(text: string): ImportRow[] {
  const rows = parseCsv(text.replace(/^\uFEFF/, ""));
  if (rows.length < 2) return [];
  const headers = rows[0].map((header) => header.trim().toLowerCase().replace(/[\s-]+/g, "_"));
  return rows.slice(1).map((cells) => Object.fromEntries(headers.map((header, index) => [header, cells[index] ?? ""]))).map((record) => ({
    source: value(record, "source", "channel").toLowerCase().replace("walk-in", "walk_in") || "other",
    externalReference: value(record, "external_reference", "booking_reference", "reference"),
    guestName: value(record, "guest", "guest_name", "full_name", "name"), email: value(record, "email"), phone: value(record, "phone", "telephone", "whatsapp"),
    language: value(record, "language", "preferred_language") || "es", checkInDate: value(record, "check_in_date", "check_in", "arrival"), checkOutDate: value(record, "check_out_date", "check_out", "departure"),
    roomName: value(record, "room", "room_name"), bedLabel: value(record, "bed", "bed_label"), adults: Number(value(record, "adults") || 1), children: Number(value(record, "children") || 0),
    currency: value(record, "currency") || "PEN", totalMinor: minorUnits(value(record, "total", "total_amount")), channelCollectedMinor: minorUnits(value(record, "channel_collected", "channel_collected_amount")),
  }));
}

export const importTemplate = `source,external_reference,guest_name,email,phone,language,check_in_date,check_out_date,room,bed,adults,children,currency,total,channel_collected\nairbnb,ABC123,Example Guest,guest@example.com,+51999999999,en,2026-10-01,2026-10-03,Room 1,,2,0,PEN,240,80\n`;

export const hostelworldImportTemplate = `source,external_reference,guest_name,email,phone,language,check_in_date,check_out_date,room,bed,adults,children,currency,total,channel_collected\nhostelworld,HW123456,Example Guest,guest@example.com,+51999999999,en,2026-10-01,2026-10-03,Dorm 1,Bed 1,1,0,USD,36,5.40\n`;
